import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'
export default class UserLegal extends ApiBase {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/user/legal`)
  }

  reject(id, showProgress) {
    return this._request({
      action: `${id}/reject`,
      method: 'PATCH',
      showProgress
    })
  }

  approve(id, showProgress) {
    return this._request({
      action: `${id}/approve`,
      method: 'PATCH',
      showProgress
    })
  }

  unblock(userId, showProgress) {
    return this._request({
      action: `${userId}/unlock`,
      method: 'PATCH',
      showProgress
    })
  }

  changePassword(userId, body, showProgress) {
    return this._request({
      action: `${userId}/password`,
      body,
      method: 'PATCH',
      showProgress
    })
  }

  delete(userId, model, showProgress) {
    return this._request({
      action: userId,
      method: 'DELETE',
      body: model,
      showProgress
    })
  }
}
